import {
  FilterOperator,
  IntegrationType,
  useIntegrationsListLazyQuery,
} from '@kinetic-ui/data-layer';
import { DataSource, FormOption } from '@qfa/forms';
import { getNodes } from 'kineticUtils';
import { useCallback } from 'react';

export const useAlertNamesDataSource = (): DataSource<FormOption[]> => {
  const [getAlertNames] = useIntegrationsListLazyQuery({
    variables: {
      filters: [
        {
          field: 'config.integrationType',
          operator: FilterOperator.Equals,
          value: IntegrationType.Alert,
        },
      ],
    },
  });
  const load = useCallback(async () => {
    const { data } = await getAlertNames();
    const alertOptions = getNodes(data?.integrations).map((alert) => ({
      label: alert.name,
      value: alert.id,
    }));

    return alertOptions as FormOption[];
  }, [getAlertNames]);

  return { load };
};
